import { TransactionReports } from "../../../shared/components/transaction-reports/transaction-reports";

export function FrontofficeTransactionReports() {
  return <TransactionReports type="fo" />;
}
